import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PAYMENT_ICON_MAP, PaymentIconSpec } from './payment-icon.constant';
import { MAX_VISIBLE_PAYMENT_ICONS } from '../../../common/constants';

export interface StripeCapability { name: string; status: 'active' | string; }

@Component({
  selector: 'vsf-payment-icon-strip',
  templateUrl: './payment-icon-strip.component.html',
  styleUrls:  ['./payment-icon-strip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentIconStripComponent  {

  /** Raw capabilities coming from your backend / Stripe */
  @Input() set capabilities(value: StripeCapability[] | null | undefined) {
    this.buildIconList(value ?? []);
  }

  visibleIcons: { path: string; tooltip: string }[] = [];
  overflowTooltips: string[] = [];

  private buildIconList(raw: StripeCapability[]) {
    const flattened: { path: string; tooltip: string }[] = [];

    raw
      .filter(c => c.status === 'active')
      .forEach(c => {
        const spec: PaymentIconSpec | undefined = PAYMENT_ICON_MAP[c.name];
        if (!spec) return;

        spec.svgPaths.forEach(p =>
          flattened.push({ path: p, tooltip: spec.displayName })
        );
      });

    // First 16 inline, the rest go into the ellipsis tooltip
    this.visibleIcons   = flattened.slice(0, MAX_VISIBLE_PAYMENT_ICONS);
    this.overflowTooltips = flattened.slice(MAX_VISIBLE_PAYMENT_ICONS).map(i => i.tooltip);
  }
}
